// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1xIt0","obliqueLineWrap":"membershipbadge_obliqueLineWrap__25cLO","obliqueLine":"membershipbadge_obliqueLine__2SzbD"};